import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../utils/style';

export const TEXT_MARGIN = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const CONTENT_ADVISORY_MARGIN = {
  [HD]: 40,
  [FULL_HD]: 40,
};

export const ICON_SIZE = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const defaultContext = makeDefaultStylingContext();

export const ICON_MARGINS = {
  [HD]: {
    marginRight: -1,
  },
  [FULL_HD]: {
    marginRight: -1,
  },
};

export const colors = {
  details: makeThemeColor(PRIMARY, 0.8),
  description: makeThemeColor(PRIMARY),
  highlight: makeThemeColor(PRIMARY, 0.8),
};

export const getInitialStyle = ({ screenSize } = defaultContext) => {
  const detailsFont = getFont(FONT.BERLIN_1, screenSize);
  const descriptionFont = getFont(FONT.OTTAWA_1, screenSize);

  return {
    flex: {
      direction: 'column',
    },
    Highlight: {
      text: {
        ...detailsFont,
        maxLinesSuffix: '...',
        maxLines: 1,
      },
      flexItem: {
        marginBottom: TEXT_MARGIN[screenSize],
      },
    },
    ContentAdvisory: {
      flexItem: {
        marginBottom: CONTENT_ADVISORY_MARGIN[screenSize],
      },
    },
    Description: {
      text: {
        ...descriptionFont,
        maxLinesSuffix: '...',
      },
    },
    Details: {
      text: {
        ...detailsFont,
        maxLinesSuffix: '...',
        maxLines: 1,
      },
    },
  };
};
